import { render, staticRenderFns } from "./PromotionDataSummary.vue?vue&type=template&id=be3b6112"
import script from "./PromotionDataSummary.vue?vue&type=script&lang=js"
export * from "./PromotionDataSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports